import React from 'react';
import './UserMetricCard.css';

interface UserMetricCardProps {
  title: string;
  value: string;
  color?: 'default' | 'green' | 'blue' | 'red';
}

const UserMetricCard: React.FC<UserMetricCardProps> = ({
  title,
  value,
  color = 'default',
}) => {
  return (
    <div className={`user-metric-card metric-${color}`}>
      <h3 className="user-metric-title">{title}</h3>
      <div className={`user-metric-value value-${color}`}>{value}</div>
    </div>
  );
};

export default UserMetricCard;

